export default __webpack_public_path__ + "static/media/user_guide6.61496328.png";